<div class="modal-header">
  <h5 class="modal-title">Chi Tiết Danh Mục</h5>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  
  <div class="container">
    <div class="row">
      <!-- Left Column -->
      <div class="col-md-6">
        <!-- Name -->
        <div class="form-group">
          <p><strong>Tên:</strong> {{ selectedItem.name }}</p>
        </div>
  
        <!-- Code -->
        <div class="form-group">
          <p><strong>Mã:</strong> {{ selectedItem.code }}</p>
        </div>
  
        <!-- Parent Code -->
        <div class="form-group">
          <p><strong>Mã Cha:</strong> {{ selectedItem.parentCode || 'N/A' }}</p>
        </div>
  
        <!-- Search Category -->
        <div class="form-group">
          <p><strong>Danh Mục Tìm Kiếm:</strong> {{ selectedItem.searchCategory }}</p>
        </div>
      </div>
  
      <!-- Right Column -->
      <div class="col-md-6">
        <!-- Not for Loan -->
        <div class="form-group">
          <p><strong>Không Cho Mượn:</strong> {{ selectedItem.notForLoan ? 'Có' : 'Không' }}</p>
        </div>
  
        <!-- Rental Charge -->
        <div class="form-group">
          <p><strong>Phí Thuê:</strong> {{ selectedItem.rentalCharge }} USD</p>
        </div>
  
        <!-- Daily Rental Charge -->
        <div class="form-group">
          <p><strong>Phí Thuê Theo Ngày:</strong> {{ selectedItem.dailyRentalCharge }} USD/ngày</p>
        </div>
  
        <!-- Hourly Rental Charge -->
        <div class="form-group">
          <p><strong>Phí Thuê Theo Giờ:</strong> {{ selectedItem.hourlyRentalCharge }} USD/giờ</p>
        </div>
  
        <!-- Default Replacement Cost -->
        <div class="form-group">
          <p><strong>Chi Phí Thay Thế Mặc Định:</strong> {{ selectedItem.defaultReplacementCost }} USD</p>
        </div>
  
        <!-- Processing Fee -->
        <div class="form-group">
          <p><strong>Phí Xử Lý (khi mất):</strong> {{ selectedItem.processingFee }} USD</p>
        </div>
  
        <!-- Checkin Message -->
        <div class="form-group">
          <p><strong>Tin Nhắn Khi Trả:</strong> {{ selectedItem.checkinMessage }}</p>
        </div>
  
        <!-- Library Limitations -->
        <div class="form-group">
          <p><strong>Hạn Chế Thư Viện:</strong> {{ selectedItem.libraryLimitations || 'N/A' }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="col-md-12 text-right d-flex justify-content-end align-items-center">
    <!-- Close Button -->
    <button type="button" class="btn btn-outline-secondary mr-2" (click)="closeModal()">
      <i class="fas fa-times"></i> Đóng
    </button>
  </div>
</div>

